module.exports = __webpack_public_path__ + "img/icon／1.bfe6de06.png";